import { render, staticRenderFns } from "./langSwitcher.vue?vue&type=template&id=cacc540e&scoped=true&lang=pug&"
import script from "./langSwitcher.vue?vue&type=script&lang=ts&"
export * from "./langSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./langSwitcher.vue?vue&type=style&index=0&id=cacc540e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacc540e",
  null
  
)

export default component.exports